<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Página: {{ articles.page.name }}</span>
      </h1>
    </div>
  </div>


  <div class="align p-4 space_title">
    <div class="card">
      <div class="p-4" id="table_filter">
        <div class="row">
          <div class="col-12 col-md-8 mb-2 mb-md-0">
            <InputText placeholder="Buscar" v-model="filter.search" />
          </div>
          <div class="col-12 col-md-4">
            <InputDatePicker placeholder="Data" v-model="filter.date" range />
          </div>
        </div>
      </div>

      <div class="p-2 pb-2 divisor_bottom" v-if="articles.chart">
        <ReportChart :data="articles.chart" />
      </div>

      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Visitas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, key) in articles.data" :key="key">
            <td>
              {{ article.title }}
            </td>
            <td>
              {{ $numberFormat(article.views) }}
            </td>
            <td class="actions" width="100">
              <button class="btn btn-secondary btn_action_responsive" type="button" @click="openShareModal(article)">
                <span>Compartilhar</span>
                <i class="fa-solid fa-share-nodes"></i>
              </button>
            </td>
          </tr>
          <tr class="no_result" v-if="!articles.data || (articles.data && !articles.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>


    <ListPagination class="mt-4" :links="articles.meta.links" />
  </div>

  <ShareModal
    v-model="showShareModal"
    :article="articleToShare"
    @shared="onShared"
    @pageShared="onPageShared"
  />
</template>
  
<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useReportStore } from '@/stores/ReportStore'
import { useArticleStore } from '@/stores/ArticleStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import ShareModal from '@/components/ShareModal.vue';
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputText from '@/components/InputText.vue'
import InputDatePicker from '@/components/InputDatePicker.vue'
import moment from 'moment';
import RedirectBack from '@/components/RedirectBack.vue';
import ReportChart from '@/components/ReportChart.vue';

const loader = inject('$loader');
const articleStore = useArticleStore();
const showShareModal = ref(false);
const articleToShare = ref({});

const router = useRouter();
const route = useRoute();
const reportStore = useReportStore();
const { filter, articles } = storeToRefs(reportStore);

onBeforeMount(() => {
  filter.value.search = null;
  reportStore.articles = {
      data: {},
      meta: {},
      page: {},
      chart: null,
  };

  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  if (route.query.date_start) {
    filter.value.date = [route.query.date_start, route.query.date_end];
  }else {
    filter.value.date = [moment().utcOffset(-3).format('YYYY-MM-DD'), moment().utcOffset(-3).format('YYYY-MM-DD')];
  }

  loadPage();
});

const dateStart = computed({
  get: () => filter.value.date[0],
});

const dateEnd = computed({
  get: () => filter.value.date[1],
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPage();
  }
});

watch(() => filter.value.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: filter.value.search };
  router.push({ query: new_query }).then(() => {
    loadPage();
  });
}, 500));

watch(() => filter.value.date, debounce(() => {
  const new_query = { ...route.query, page: 1, date_start: dateStart.value, date_end: dateEnd.value };
  router.push({ query: new_query }).then(() => {
    loadPage();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
 
async function loadPage() {
  const id = route.params.id;

  loader.show();
  let params = {
    page: parseInt(route.query.page),
    search: filter.value.search,
    date_start: dateStart.value,
    date_end: dateEnd.value
  }

  await reportStore.getPage(id, params);
  loader.hide();
}

async function openShareModal(article) {
  if (!article.id_article) {
    return;
  }

  loader.show();
  const result = await articleStore.getShareArticle(article.id_article);
  loader.hide();

  if (result.success) {
    articleToShare.value = result.data;
    showShareModal.value = true;
  }
}

function onShared() {
  // Atualiza a data de compartilhamento na lista
}

function onPageShared({ pageKey, sharedAt }) {
  // Atualiza a página compartilhada
  if (articleToShare.value.pages) {
    articleToShare.value.pages[pageKey].shared = 1;
    articleToShare.value.pages[pageKey].shared_at = sharedAt;
  }
}
</script>

<style scoped>
.divisor_bottom {
  border-bottom: 1px #d7d7d7 solid;
}
</style>
